export default __webpack_public_path__ + "static/img/aboutUs.1823192.png";